/**
 * Created by
 */


var extend = require("extend")
var window = require("../../../support/window.js")

var woxinSupport = require("../../woxinSupport.js")
var commons = require("./commons.js")

/**
 * 默认配置
 * @type {{urls: {base: string, product: {productInfo: string}}}}
 */
var defaultConfigs = {
    urls : {
        base : '/data/'
    }

};

var sysConfigKey = "JXSM_FDAPI";

/**
 * 获取环境配置
 * @returns {*}
 */
var getEvnConfig = function() {
    if (window[sysConfigKey]) {
        return window[sysConfigKey];
    } else {
        return {};
    }
}

/**
 * 获取最终配置
 */
var getConfigRelease = function() {
    return extend(true, defaultConfigs, getEvnConfig());
}

/**
 * 获取地址配置
 * @param group
 * @param name
 * @returns {string}
 */
var getConfigUrl = function(group, name) {
    var conf = getConfigRelease()
    var url = conf.urls.base + conf.urls[group][name];
    // 增加我信登陆支持
    return new Promise(function(resolve, reject) {
        woxinSupport.loginInfo(function(mobile, token) {
            if (mobile && token) {
                // 优先使用phone+token
                url = url + (url.indexOf("?") >= 0 ? "&" : "?") + "mobile=" + mobile + "&token=" + token;
                resolve(url);
            } else {
                // 尝试使用terminalId
                var terminalId = commons.getUrlParmar("terminalId");
                var mobile = commons.getUrlParmar("mobile");
                var token = commons.getUrlParmar("token");
                if (terminalId && terminalId.length > 0) {
                    url = url + (url.indexOf("?") >= 0 ? "&" : "?") + "terminalId=" + terminalId;
                    resolve(url);
                } else if (mobile && mobile.length > 0) {
                    url = url + (url.indexOf("?") >= 0 ? "&" : "?") + "mobile=" + mobile + "&token=" + token;
                    resolve(url);
                } else {
                    resolve(url);
                }
            }
        });
    });
};

module.exports = {
    defaultConfigs : defaultConfigs,
    getConfigUrl : getConfigUrl
}


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/func/fdapi/commons/config.js
// module id = 7
// module chunks = 0